import { dbGet, dbRemove, dbSet } from "../../db/map";
import { ActionStatusTypes } from "../enum/ActionStatusTypes";
import * as systemUtils from './systemUtils'

export const pushHistoryEvent = (info, model, register, idFunction) => {
  if (info.status !== ActionStatusTypes.SUCCESS) {
    return;
  }

  const _children = [];

  if (info.rewind) {
    const targetEvent = getHistoryEvent(info.rewind, register);
    _children.push(targetEvent.children);
  }

  register.push({
    time: info.time,
    name: info.header,
    group: info.group,
    description: info.description,
    rewind: info.rewind,
    index: register.length + 1,
    inactive: 0,
    idFunction: idFunction,
    children: _children,
  });

  const parsedModel = JSON.stringify(model)

  saveEvent(info.time, parsedModel);
  saveSessionModel(parsedModel);
};

export const getHistoryEvent = (time, register) => {
  for (let i = 0; i < register.length; i++) {
    if (time === register[i].time) {
      return register[i];
    }
  }

  throw Error("The requested record is non-existent");
};

export const getNextHistoryEvent = (time, register) => {
  for (let i = 0; i < register.length; i++) {
    if (time === register[i].time) {
      if (i + 1 < register.length) {
        return register[i + 1];
      }

      return null;
    }
  }
};

export const markRecordsAsInactiveFrom = (time, register) => {
  let marker = false;
  let record;

  register.forEach((e) => {
    if (marker) {
      e.inactive += 1;
      record.children.push(e.time);
    }

    if (time === e.time) {
      record = e;
      marker = true;
    }
  });
};

export const markRecordsActiveFrom = (time, register) => {
  let marker = false;

  register.forEach((e) => {
    if (marker) {
      e.inactive -= 1;
    }

    if (time === e.time) {
      e.children = [];
      marker = true;
    }
  });
};

export const getLastEvent = (register) => {
  if (register.length === 0) {
    return null;
  }

  return register[register.length - 1];
};

export const getHistoryState = (time) => {
  return JSON.parse(loadEvent(time));
};

export const deleteEventLast = (register) => {
  const event = popLastEvent(register);
  deleteEvent(event.time);
};

export const deleteEventsInactive = (register) => {
  const inactive = [];

  register.forEach((e, i) => {
    if (e.inactive > 0) {
      inactive.push(i);
      deleteEvent(e.time);
    }
  });

  let indexRemoved = 0;

  inactive.forEach((e) => {
    register.splice(e - indexRemoved, 1);
    indexRemoved++;
  });
};

const deleteEvent = (time) => {
  removeEvent(time);
};

const popLastEvent = (register) => {
  return register.pop();
};

//--------------------------------------------------------------

export const saveSessionModel = (value) => {
  systemUtils.saveToSessionStorage("model", value);
}

export const loadSessionModel = () => {
  return systemUtils.loadFromSessionStorage("model");
}

export const saveBackupSessionModel = (value) => {
  systemUtils.saveToSessionStorage("backup-model", value);
}

const saveEvent = (key, value) => {
  dbSet(key, value);
};

const loadEvent = (key) => {
  return dbGet(key);
};

const removeEvent = (key) => {
  dbRemove(key);
};
